'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('admin-page-list', {
      url: '/admin/page/list',
      template: '<admin-page-list></admin-page-list>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/page/list/page-list.routes.js